import createClient from "openapi-fetch";
import type { paths, components } from "./schema";

export type Schemas = components["schemas"];
export type User = Schemas["User"];
export type Me = Schemas["Me"];
export type Workspace = Schemas["Workspace"];
export type WorkspaceWithRole = Schemas["WorkspaceWithRole"];
export type WorkspaceMember = Schemas["WorkspaceMember"];
export type Invitation = Schemas["Invitation"];
export type InvitationPreview = Schemas["InvitationPreview"];
export type WorkspaceRole = Schemas["WorkspaceRole"];
export type ErrorBody = Schemas["ErrorBody"];

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export function createApi(baseUrl = "") {
  return createClient<paths>({ baseUrl, credentials: "include" });
}

export type Api = ReturnType<typeof createApi>;

/** Unwrap an openapi-fetch result into data, throwing `ApiError` on failure. */
export function unwrap<T>(res: { data?: T; error?: unknown; response: Response }): T {
  if (res.error !== undefined || !res.response.ok) {
    const err = (res.error ?? {}) as Partial<ErrorBody>;
    throw new ApiError(res.response.status, err.code ?? "common.unknown", err.message ?? res.response.statusText);
  }
  return res.data as T;
}
